<template>
	<div class="onlineProduct">
     <div class="first_hader">
        <div class="check_header">
            <router-link to="/productModel">
                <el-button size="small" type="primary"><i class="iconfont icon-fanhui-"></i> {{$t('other.a605')}}</el-button>
            </router-link>
        </div>

        <div class="second_header">
           <div>
                 {{$t('other.a386')}}
                <el-select   @change="getShopItems01" v-model="chooseParams[0]" :placeholder="$t('other.a50')">
                <el-option
                    v-for="item in shopOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
                </el-select>
           </div>
           <div>
               <el-button type="primary" @click="comfrim()">{{$t('other.a274')}}</el-button>
           </div>
        </div>
    </div>
    <div class="order_Box">
          <div class="item_wrapper" v-for="(item,index) in mygoodslist" :key="index">
              <div class="item_header">
                  <el-checkbox class="header_item" @change="target(item)" v-model="item.checked"></el-checkbox>
                  <span class="header_item">{{$t('other.a68')}}：{{item.itemId}}</span>
                  <span class="header_item">{{$t('other.a838')}}：{{item.shopName}}</span>
                 
              </div>
              <div class="main_content">
                  <div class="item_left">
                      <div class="pic_box">
                      <img style="width:100%" :src="item.image">
                        </div>
                        <div class="item_name">
                            {{item.name}}
                        </div>
                  </div>
                   <div class="item_center">
                       <div>{{$t('other.a1348')}}：{{item.isPreOrder ? $t('other.a191') : $t('other.a192')}}</div>
                       <div>{{$t('other.a1349')}}:{{item.stock}}</div>
                       <div>{{$t('other.a1350')}}：{{item.sales}}</div>
                       <div>{{$t('other.a360')}}：{{item.status}}</div>
                      
                   </div>
                  <div class="item_right">
                      <div class="ttp" v-for="(ttp,indexOne) in item.variations" :key="indexOne">
                          <div class="ttp_item">Sku：{{ttp.variationSku}}</div>
                          <div class="ttp_item">skuName：{{ttp.name}}</div>
                          <div class="ttp_item">{{$t('other.a310')}}：{{ttp.stock}}</div>
                          <div class="ttp_item">{{$t('other.a831')}}：{{ttp.price}}</div>
                      </div>
                  </div>
              </div>
          </div>
    </div>      

		
    <!-- 分页器 -->
    <div  class="Pager">
        <el-pagination
            @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage1"
        :page-sizes="[15, 20, 30, 50]"
        :page-size="15"
        layout="total, sizes, prev, pager, next, jumper"
        :total="goodsTotal">
        </el-pagination>
    </div>
	</div>
</template>

<script>
	import QrcodeDialog from '../../../components/dialog/qrcodeDialog.vue'
	import utils from  '../../../utils/utils.js'


	import {
		mapState,
		mapActions,
		mapMutations
	} from 'vuex'
	export default {
		data() {
			return {
				userShops: JSON.parse(localStorage.getItem('shopIdInfo')) ,
				userShopslazada:JSON.parse(localStorage.getItem('lazadashopId')),
				userInfo: JSON.parse(localStorage.getItem('userInfo')),
				lazadashopId: JSON.parse(localStorage.getItem('lazadashopId')),
				shophasAuthorization:JSON.parse(localStorage.getItem('shophasAuthorization')),
                shopOptions:[],

				shopList: [{
					label: this.$t('mygoods').allShop,
					value: '',
					children:null,
				},],
				storeList: [],
				status: {
					NORMAL: this.$t('other.a1082'),
					UNLIST: this.$t('other.a1083'),
					BANNED: this.$t('other.a1911'),
					DELETED: this.$t('other.a1912')
				},
				shipId: {
					value:{
						label:''
					}
				},
				chosedStore: '',
				itemNameQuery: '',
				statusValue: '',
				isChooseList: [],
				syncOrders:false,
				isParts:true,
				bindItemList: [],
				caigouTable: false,
				productOptions:[{
					 value: 'NORMAL',
					 label: this.$t('other.a1636')
				},{
					 value: 'UNLIST',
					 label: this.$t('other.a1083')
				},{
					 value: 'BANNER',
					 label: this.$t('other.a1637')
				},],
				productStatua:'NORMAL',
				bindTable: false,
				count: 0,
				catergoryType:0,
				active:-1,
				dialogVisible: false,
				showStore:false,
				remindDialog: false,
				itemCount: 0,
				flagNum:0,
				disabled:false,
				arr: [],
				chooseParams:null,
				isBindItemModel: false,
				sellerMessage: "",
				visiableMessage: '',
				stockRemindList: [],
				remindCount: 0,
				selectShop: '',
				offset:15,
				currentPage:0,
				type:0,
				currentPage1:0,
				goodsName:null,
				cost_prict:'',
				sku_name:'',
				storetable:false,
				input10:'',
				bindSuccess:[],
				listCopy:[],
				bindError:[],
				bindreport:false,
				addItmes:this.$t('other.a1913'),
				activeTheOne:true,
				activeName: 'first',
				isShopee:true,
				showSales:false,
				salesItem:null,
				choseCategroyId:0,
				whichMethods:null,
				options:[{
					label:this.$t('other.a1933'),
					value:true,
				},{
					label:this.$t('other.a1934'),
					value:false,
				}],
				selectedOptions2:[],
				text:'',
				options5:[],
				value10:[],
				getDataList:{
					categoryIds:null,
					offset:null,
					page:null,
					userId:null,
					shopIds: null,
					status:null,
					itemName:null,
				}
				
			}
		},
		components: {
			QrcodeDialog 
		},
		
		computed: {
			...mapState({
				mygoodslist: state => state.mygoods.mygoodslist,
				userId: state => state.shopaccess.userInfo.userId,
				userName: state => state.shopaccess.userInfo.userName,
				userPos: state => state.shopaccess.userInfo.userPos,
				goodsTotal:state => state.mygoods.goodsTotal,
				successtotal:state => state.mygoods.successtotal,
				errorList:state => state.mygoods.errorList,
				succesList:state => state.mygoods.succesList,
				curCodeList:state => state.mygoods.curCodeList,
				lazadaitems:state => state.mygoods.lazadaitems,
				lazadaCount:state => state.mygoods.lazadaCount,
				cateGoryListCopy:state => state.mygoods.cateGoryListCopy,
				already:state => state.mygoods.already,
				
				
			}),
			
	
		
				
		},
		watch:{
		
		},
		created(){
			
			this.init()
			
			// this.handleClick()
			
		},
		methods: {
			...mapActions('mygoods', [
			'getShopAllItems',
			'addGoodsInStore',
			'getBindInfo',
			'tongBuShopee',
			'getLazadaWarehouseitems',
			'tongBuLazada',
			'getGoodsOrder',
			'getItemSales',
			'getInventoryTurnover',
			'getCategoryByshop',
			'batchCreateStoreItem',
			'addNotProductInStore'
			]),
			
			...mapMutations('mygoods', [
			'GET_CURCODE_LIST_NULL',
			'SET_SUCCESS_ERROR_NULL',
			'KEEP_CHOOSED_ITEM',
			'SET_ITEM_TRUE'
				
			]),
			
		
			
	
			
		

            comfrim(){
                let obj=this.mygoodslist.find(item => item.checked)
                console.log(obj.itemId)
                this.$router.push({path:'/productModel',query:{itemId:obj.itemId}})
            },
			
		
			

	
            target(item){
                if(item.checked){
                    this.mygoodslist.forEach(p => {
                    p.checked=false
                })
                item.checked=!item.checked
                    return
                }
              
                console.log(item)
            },


			
		
			init(){
				if(this.shophasAuthorization){
					this.userShops.forEach(item => {
					let oop={
						label:item.shopName,
						value:item.shopId
					}
					this.shopList.push(oop)
					})

                    let arr=JSON.parse(localStorage.getItem('userInfo')).shopeeShops
                    arr.forEach(p => {
                        this.shopOptions.push({
                            label:p.shopName,
                            value:p.shopId
                        })
                    })

                    
					this.chooseParams=[this.shopList[1].value]
					this.selectShop=this.shopList[1].value
					this.selectedOptions2[0]=this.shopList[1].value
					
					this.getShopItems01()
				}	
			},
			

		
	
			//获取导入商品页面的数据
			getShopItems01() {
				this.getDataList.categoryIds=this.chooseParams.length == 1  ? null : this.chooseParams
				this.getDataList.offset=this.offset
				this.getDataList.page=this.currentPage
				this.getDataList.userId=this.userId
				this.getDataList.shopIds= [this.chooseParams[0]]
				this.getDataList.status=this.productStatua
				this.getDataList.itemName=''

				this.getShopAllItems(this.getDataList)
			},

		

		
	

			
			
			//控制每页显示订单条数
			handleSizeChange(val) {
							 console.log(`每页 ${val} 条`);
							 this.offset=parseInt(`${val}`)
							 this.getDataList.offset=parseInt(`${val}`)
							 this.handleCurrentChange()
			  },
			  //显示当前第几页
			  handleCurrentChange(val) {
						this.currentPage=(parseInt(`${val}`) -1) * this.offset
						this.getDataList.page=this.currentPage
						 this.getShopAllItems(this.getDataList)
						 this.currentPage=0
			  },
		
	


		}
	}
</script>

<style lang="scss" scoped>
.onlineProduct{

    // flex:1;
    // margin: 50px 0 0 223px;
    box-sizing: border-box;
    padding: 0 20px;
    margin-bottom: 60px;
    background-color: #eee;

    .first_hader{
        position: fixed;
        top: 50px;
        left:223px;
        width: 86%;
        background-color: #fff;
        padding: 15px 10px;
        box-shadow:  0 2px 1px -1px rgba(0,0,0,0.2);
        z-index: 9;

        .check_header{
            margin-bottom: 15px;
        }

        .second_header{
            display: flex;
            justify-content: space-between;
        }
    }

    .order_Box{
        margin-top: 132px;


        .item_wrapper{
        
        margin-bottom: 20px;
        box-shadow: 0 2px 1px -1px rgba(0,0,0,0.2);
        background-color: #fff;

        .item_header{
        height: 40px;
        border-bottom: 1px solid #efefef;
        line-height: 40px;
        font-size: 22px;
        padding: 5px 10px;

        .header_item{
            margin-right: 15px;
        }
        }

        

        .main_content{
            box-sizing: border-box;
            padding: 10px;
            display: flex;

            .pic_box{
            width: 120px;
        
            }

            .item_left{
                width: 30%;
                display: flex;
                border-right: 1px solid #efefef;

                .item_name{
                   box-sizing: border-box;
                    padding:0 10px
                }
            }

            .item_center{
                width: 14%;
                border-right: 1px solid #efefef;
                padding: 0 10px;
            }

            .item_right{
                flex:1;
                margin: 0 10px;
                .ttp{
                    display: flex;
                    justify-content: flex-start;
                    border-bottom: 1px solid #efefef;
                    padding: 10px 0;

                    .ttp_item:nth-child(1){
                        width: 30%;
                        border-right: 1px solid #efefef;
                       
                    }

                    .ttp_item:nth-child(2){
                        width: 30%;
                        border-right: 1px solid #efefef;
                         padding-left: 10px;
                    }

                    .ttp_item:nth-child(3){
                        width: 20%;
                        border-right: 1px solid #efefef;
                         padding-left: 10px;
                    }

                    .ttp_item:nth-child(4){
                        width: 20%;
                         padding-left: 10px;
                    }
                }
            }
        }

    }


    }

     /deep/ .el-checkbox__inner {
    width: 20px;
    height: 20px;
  }

  /deep/ .el-checkbox__inner::after {
    height: 10px;
    left: 7px;
    width: 4px;
    font-weight: bold;
  }

  
   

    .Pager{
		position: fixed;
		bottom: 0;
		left: 235px;
		right: 0;
		height: 40px;
		line-height: 40px;
		background-color: #fff;
		text-align:right;
	}

}

	
	

</style>
